import React, { useContext } from "react";
import { ColorContext } from "..";
import Dropdown from "./Dropdown";
import styled from "styled-components";

const StyledFooter = styled.footer`
    font-size: 1rem;
    box-sizing: border-box;
    height: 10vh;
    margin: 0.5rem;
    padding: 1.5rem;
    text-align: end;
    display: flex;
    width: auto;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

function Footer() {
    const colors = useContext(ColorContext);
    return (
        <StyledFooter>
            <span style={{ color: colors, fontSize: '20px', textAlign: 'left' }}>Pre-Alpha will be deployed by NOV 30</span>
            <Dropdown color={colors} />
        </StyledFooter>
    )
}

export default Footer;